import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { merge } from 'lodash';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { palette } from './palette';
import { componentsOverrides } from './overrides';
import { customShadows } from './custom-shadows';
import { shadows } from './shadows';
import { typography } from './typography';
import { ThemeContext } from '@application/context/themeContext';
import { breakpoints } from './breakpoints';
export default function CustomThemeProvider({ children }) {
    const { theme: selectedTheme } = useContext(ThemeContext);
    const baseOption = useMemo(() => ({
        palette: palette(selectedTheme),
        shadows: shadows(selectedTheme),
        customShadows: customShadows(selectedTheme),
        typography,
        shape: { borderRadius: 8 },
        breakpoints,
    }), [selectedTheme]);
    const memoizedValue = useMemo(() => merge(
    // Base
    baseOption), [baseOption]);
    const theme = createTheme(memoizedValue);
    theme.components = merge(componentsOverrides(theme));
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), children] }));
}
